import { render, staticRenderFns } from "./BaseAvatarUserGroup.vue?vue&type=template&id=ba96d9fc&"
import script from "./BaseAvatarUserGroup.vue?vue&type=script&lang=js&"
export * from "./BaseAvatarUserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports